import React from 'react';
import { QuizOption } from '../../types';

interface ExamSelectionProps {
  selectedExam: string;
  examOptions: QuizOption[];
  loadingExams: boolean;
  onExamChange: (examId: string) => void;
}

const ExamSelection: React.FC<ExamSelectionProps> = ({
  selectedExam,
  examOptions,
  loadingExams,
  onExamChange
}) => {
  return (
    <>
      {/* Exam Selection */}
      <div className="mb-4">
        <label className="form-label fw-semibold">
          <i className="fas fa-graduation-cap me-2 text-primary"></i>
          Select Exam <span className="text-danger">*</span>
        </label>
        <select 
          className="form-select form-select-lg"
          style={{ borderRadius: '12px' }}
          value={selectedExam}
          onChange={(e) => onExamChange(e.target.value)}
          disabled={loadingExams}
        >
          <option value="">
            {loadingExams ? 'Loading exams...' : 'Choose an exam...'}
          </option>
          {examOptions.map(exam => (
            <option key={exam.value} value={exam.value}>
              {exam.label}
            </option>
          ))}
        </select>
        {loadingExams && (
          <div className="mt-2">
            <span className="spinner-border spinner-border-sm me-2"></span>
            <small className="text-muted">Loading available exams...</small>
          </div>
        )}
      </div>

      {/* Show helpful message when no exam is selected */}
      {!selectedExam && !loadingExams && (
        <div className="alert alert-info border-0" style={{ borderRadius: '12px', backgroundColor: '#e3f2fd' }}>
          <div className="d-flex align-items-center">
            <i className="fas fa-info-circle text-primary me-2"></i>
            <span className="text-primary">
              <strong>Get Started:</strong> Please select an exam above to configure your custom quiz
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default ExamSelection;